import React from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import ContentSplitSections from '../components/ContentSplitSections';
import { Link } from 'react-router-dom';
import '../styles/waterFeature.css';
import CTASection from '../components/CTASection';

// Infrastructure & Engineering sections
const infrastructureSections = [
  {
    title: "Pump System Design and Construction",
    text: `Engineering Water at Scale\n\nAll Seasons doesn't just install pumps – we design and build complete irrigation systems. These sophisticated structures are the heart of large-scale water distribution, engineered to serve entire communities and developments.\n\nOur Pump System Capabilities:\n• Automatic Filtration System\n• Multi-source water integration\n• VFD Control Panels\n• Emergency backup infrastructure\n•24/7 System Communication`,
    image: "/images/water/pumpBlue.png",
    alt: "Custom Built Pump House",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/gallery/water",
  },
  // {
  //   title: "River Water Extraction Systems",
  //   text: `Harnessing Natural Water Sources\n\nOur engineering team designs and installs sophisticated river extraction systems that provide sustainable water supply for large properties and communities. These systems require extensive permitting, environmental consideration, and technical expertise that few possess.\n\nSystem Components:\n• Intake structure design\n• Filtration systems\n• Pumping station construction\n• Distribution network engineering\n• Water rights monitoring`,
  //   image: "/images/water/riverSystem.jpg",
  //   alt: "River Water Extraction",
  //   reverse: true,
  //   buttonText: "View Our Work",
  //   buttonLink: "/gallery/water",
  // },
  {
    title: "Waterway Management",
    text: `Maintaining water flow systems through creeks, streams, ponds.\n• Clean and maintain\n• Construction\n• Change or Correct Water Flow\n• Community Wide Systems`,
    image: "/images/water/waterManage.JPG",
    alt: "Water Management",
    reverse: true,
    buttonText: "View Our Work",
    buttonLink: "/gallery/water",
  }
];

// Residential & Estate sections
const residentialSections = [
  {
    title: "Irrigation Systems",
    text: `Precision Water Delivery\n\nOur irrigation systems go beyond basic sprinklers. We engineer complete water management solutions that account for elevation changes, soil types, and microclimates across your property.\n\nSystem Design Elements:\n• Hydraulic engineering for optimal pressure\n• Zone design based on plant requirements\n• Smart controller integration\n• Drip and micro-irrigation for efficiency\n• Integration with larger water infrastructure`,
    image: "/images/water/irrigationRock.JPG",
    alt: "Estate Irrigation System",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/gallery/water",
  },
  {
    title: "Pond & Lake Creation",
    text: `Engineered Water Features\n\nFrom reflection ponds to multi-acre lakes, All Seasons creates water bodies that serve both aesthetic and functional purposes. Each is engineered for sustainability with proper circulation and filtration.\n\nPond Engineering:\n• Site analysis and excavation\n• Liner systems and natural sealing\n• Circulation and aeration design\n• Eco-friendly algae management programs\n• Integration with irrigation reserves`,
    image: "/images/water/pondCreated1.jpg",
    alt: "Engineered Pond System",
    reverse: true,
    buttonText: "View Our Work",
    buttonLink: "/gallery/water",
  },
  {
    title: "Artistic Water Features",
    text: `Craftsmanship in Water\n\nOur craftsmen create water features that become focal points of your landscape. Using natural stone and advanced hydraulics, we build features that look natural yet perform flawlessly.\n\nWater Feature Craftsmanship:\n• Natural stone waterfall construction\n• Stream design with proper flow rates\n• Fountain installation and programming\n• Pondless systems for safety\n• Year-round operational design`,
    image: "/images/water/waterfall.png",
    alt: "Natural Water Feature",
    reverse: false,
    buttonText: "View Our Work",
    buttonLink: "/gallery/water",
  }
];

const Water = () => {
  
  return (
    <div className="water-page">
      <Navbar />
      <Breadcrumb />
      
      {/* Hero Section */}
      <section className="water-hero">
        <img 
          src="/images/water/pondHouse.png" 
          alt="Water Infrastructure Systems" 
          className="hero-image"
          loading="eager"
          decoding="async"
        />
        <div className="water-hero-content">
          <h1 className="water-hero-title">IRRIGATION SYSTEMS & WATER SOLUTIONS</h1>
          <p className="hero-subtitle">
            We handle every detail of your irrigation system. From design coordination to installation and maintenance, we
ensure reliable and efficient performance season after season, year after year.
          </p>
           <div className="hero-buttons">
                      <a
                    className="btn-cta"
                    href="mailto:info@allseasons.info"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Request A Consultation</a>
                      <Link to="/gallery/water" className="btn-primary">Gallery</Link>
                    </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <div className="intro-content">
            <h2 className="section-title text-center">Water Solutions That Deliver Results</h2>
            <p className="intro-text">
              From community-scale infrastructure to elegant water features, All Seasons engineers water systems that perform reliably for decades. Our 35-year track record speaks to the precision and innovation we bring to every project.
            </p>
          </div>
        </div>
      </section>

      {/* Infrastructure & Engineering Services */}
      <section className="section bg-white section-divider-editorial">
        <div className="section-inner">
          <h2 className="section-title text-center">Infrastructure & Water Management</h2>
          <p className="section-subtitle text-center">
            Efficient, adaptable solutions for properties of every size and scope.
          </p>
        </div>
      </section>

      <ContentSplitSections sections={infrastructureSections} />

      {/* Water Feature Solutions */}
      <section className="section bg-white section-divider-editorial">
        <div className="section-inner">
          <h2 className="section-title text-center">Water Feature Solutions</h2>
          <p className="section-subtitle text-center">
            Bringing engineering expertise to create beautiful and functional water features
          </p>
        </div>
      </section>
      
      <ContentSplitSections sections={residentialSections} />

      {/* Gallery CTA */}
      <section className="section bg-white">
        <div className="section-inner text-center">
          <Link to="/gallery" className="btn-primary">
            View Our Work
          </Link>
        </div>
      </section>

      {/* Comprehensive Maintenance */}
      <section className="section bg-white section-divider-editorial">
        <div className="section-inner">
          <h2 className="section-title text-center">System Maintenance & Management</h2>
          <p className="maintenance-intro">
            We don't just build – we maintain. Every system we install comes with comprehensive
            management programs to ensure decades of reliable operation.
          </p>
          <div className="maintenance-columns">
            <div className="maintenance-column">
              <h3>Infrastructure Management</h3>
              <ul>
                <li>Pump house monitoring and operation</li>
                <li>Well system performance optimization</li>
                <li>Excavating Ponds</li>
                <li>Emergency response and repairs</li>
                <li>System upgrades and modernization</li>
              </ul>
            </div>
            <div className="maintenance-column">
              <h3>Irrigation Maintenance</h3>
              <ul>
                <li>Spring Activation</li>
                <li>Monthly maintenance inspections</li>
                <li>Flood Control</li>
                <li>Fall winterization procedures</li>
              </ul>
            </div>
            <div className="maintenance-column">
              <h3>Water Feature Services</h3>
              <ul>
                <li>Pump and filter maintenance</li>
                <li>Water quality management</li>
                <li>Eco-friendly algae treatment</li>
                <li>Waterfall Maintenance</li>
                <li>Complete system overhauls</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Backflow Prevention Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Backflow Prevention & Testing</h2>
          <div className="backflow-intro">
            <p className="compliance-notice">
              Annual backflow testing is <strong>required by Idaho law</strong> to protect water supplies 
              from contamination. All Seasons has certified technicians on staff to ensure your compliance.
            </p>
          </div>
          <div className="backflow-services">
            <div className="backflow-service" data-index="01">
              <h3>Device Testing</h3>
              <p>
                State-certified testing of all backflow prevention devices including double check 
                valves, vacuum breakers, and reduced pressure devices. We handle all required 
                documentation and reporting.
              </p>
            </div>
            <div className="backflow-service" data-index="02">
              <h3>Installation & Repair</h3>
              <p>
                Professional installation of code-compliant devices and immediate repair services 
                if your device fails testing. We stock common parts for same-day service.
              </p>
            </div>
            <div className="backflow-service" data-index="03">
              <h3>Compliance Management</h3>
              <p>
                We track testing schedules, send reminders, and maintain records for your property. 
                Stay compliant without the hassle of managing deadlines.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* The All Seasons Difference */}
      <section className="section bg-white section-divider-editorial">
        <div className="section-inner">
          <h2 className="section-title text-center">The All Seasons Difference</h2>
          <div className="difference-grid">
            <div className="difference-item">
              <h3>Scale</h3>
              <p>From single homes to entire communities – we have the infrastructure</p>
            </div>
            <div className="difference-item">
              <h3>Maintenance</h3>
              <p>We maintain what we build ensuring lasting efficiency</p>
            </div>
            <div className="difference-item">
              <h3>Construction</h3>
              <p>We build what we design – pump houses to pond systems</p>
            </div>
            <div className="difference-item">
              <h3>Experience</h3>
              <p>35 years solving Idaho's unique water challenges</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
     <CTASection 
  title="READY TO DISCUSS YOUR WATER NEEDS?"
  subtitle="FROM COMMUNITY INFRASTRUCTURE TO RESIDENTIAL SYSTEMS, WE HAVE THE ENGINEERING EXPERTISE TO DELIVER SOLUTIONS AT ANY SCALE"
  galleryLink="/Gallery/water"
  showEmergency={false}
  customNote="DON'T FORGET – ANNUAL BACKFLOW TESTING REQUIRED BY LAW. SCHEDULE YOURS TODAY."
/>

    </div>
  );
};

export default Water;